import React, { Component, useState, useEffect } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import Toggle from '~/Common-Objects/UI/Forms/Toggle/Toggle'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import IncAddCustomField from '~/pages/cp/subscribers/customfields/incAddCustomField'
import { useSelector, useDispatch } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import { alterSiteDrawer } from '~/data/actions/siteActions'
import ArraySelectComponent from './arraySelect'
import axios from '~/data/http/axios'
import fieldTypeLabel, { forcedNewFieldType } from '~/utils/fieldTypeLabel'

export default class InlineFormFields extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dragging: false,
            draggedIndex: null,
            dragOverIndex: null,
            insertPosition: 'bottom',
            selectedField: -1,
            addingField: false,
            editingField: null
        }
        this.deleteField = this.deleteField.bind(this)
        this.handleDragStart = this.handleDragStart.bind(this)
        this.handleDragOver = this.handleDragOver.bind(this)
        this.handleDragEnter = this.handleDragEnter.bind(this)
        this.handleDragLeave = this.handleDragLeave.bind(this)
        this.handleDrop = this.handleDrop.bind(this)
        this.handleDragEnd = this.handleDragEnd.bind(this)
        this.updateInputFields = this.updateInputFields.bind(this)
    }

    async updateInputFields(inputFields) {
        await this.props.updateVal(this.props.path, inputFields)
    }

    fieldList() {
        // AI / bad JSON can leave a non-array here; never call .map on that.
        return Array.isArray(this.props.elementData?.value) ? this.props.elementData.value : []
    }

    async deleteField(index) {
        const newInputFields = [...this.fieldList()]
        newInputFields.splice(index, 1)
        this.setState({ selectedField: -1 })
        await this.updateInputFields(newInputFields)
    }

    /* Drag and Drop Functions */
    handleDragStart(index) {
        this.setState({
            draggedIndex: index,
            dragging: true
        })
    }
    handleDragOver(e) {
        e.preventDefault()
        e.stopPropagation()
        e.dataTransfer.dropEffect = 'move'
    }
    handleDragEnter(index, e) {
        if (this.state.draggedIndex !== null && this.state.draggedIndex !== index) {
            const rect = e.currentTarget.getBoundingClientRect()
            const mouseY = e.clientY
            const elementMiddle = rect.top + rect.height / 2
            const insertPosition = mouseY < elementMiddle ? 'top' : 'bottom'

            this.setState({
                dragOverIndex: index,
                insertPosition
            })
        }
    }
    handleDragLeave(e) {
        const currentTarget = e.currentTarget
        const relatedTarget = e.relatedTarget

        if (!currentTarget.contains(relatedTarget)) {
            this.setState({ dragOverIndex: null })
        }
    }
    async handleDrop(e, dropIndex) {
        e.preventDefault()
        e.stopPropagation()
        const { draggedIndex, insertPosition } = this.state

        if (draggedIndex === null || draggedIndex === dropIndex) {
            this.setState({
                draggedIndex: null,
                dragging: false,
                dragOverIndex: null,
                insertPosition: 'bottom'
            })
            return
        }

        const mappedFields = [...this.fieldList()]
        const draggedItem = mappedFields[draggedIndex]
        mappedFields.splice(draggedIndex, 1)

        let insertIndex
        if (insertPosition === 'top') {
            insertIndex = draggedIndex < dropIndex ? dropIndex - 1 : dropIndex
        } else {
            insertIndex = draggedIndex < dropIndex ? dropIndex : dropIndex + 1
        }

        mappedFields.splice(insertIndex, 0, draggedItem)
        await this.updateInputFields(mappedFields)

        if (this.state.selectedField === draggedIndex) {
            this.setState({ selectedField: insertIndex })
        } else if (this.state.selectedField > draggedIndex && this.state.selectedField <= dropIndex) {
            this.setState({ selectedField: this.state.selectedField - 1 })
        } else if (this.state.selectedField < draggedIndex && this.state.selectedField >= dropIndex) {
            this.setState({ selectedField: this.state.selectedField + 1 })
        }

        this.setState({
            draggedIndex: null,
            dragging: false,
            dragOverIndex: null,
            insertPosition: 'bottom'
        })
    }
    handleDragEnd() {
        this.setState({
            draggedIndex: null,
            dragging: false,
            dragOverIndex: null,
            insertPosition: 'bottom'
        })
    }
    /* End Drag and Drop Functions */

    render() {
        const mappedFields = this.fieldList()

        var style = {}
        if (this.props.elementData?.optionFullWidth) style = { flex: '100%' }

        const dropLineStyle = {
            position: 'absolute',
            left: 0,
            right: 0,
            height: 2,
            backgroundColor: '#15AC98',
            borderRadius: 1,
            pointerEvents: 'none',
            zIndex: 2
        }

        if (this.state.addingField) {
            return (
                <AddField
                    existingFields={mappedFields}
                    updateVal={this.props.updateVal}
                    path={this.props.path}
                    done={() => this.setState({ addingField: false, editingField: null })}
                    selectedField={this.state.editingField}
                    onFieldsChanged={this.updateInputFields}
                />
            )
        }
        return (
            <div className='dndEditorv2-dd_toolHolder' style={style}>
                <div className='dd_inputTool'>
                    <div
                        onDragOver={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                        }}
                    >
                        {mappedFields.map((field, index) => {
                            const cardStyle = {
                                width: '100%',
                                border: '1px solid #E1E1E0',
                                borderRadius: '8px',
                                padding: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'move',
                                backgroundColor: 'white'
                            }

                            if (this.state.selectedField === index) {
                                cardStyle.border = '1px solid #15AC98'
                            }
                            if (this.state.dragging && this.state.draggedIndex === index) {
                                cardStyle.opacity = 0.5
                            }

                            const showDropLine =
                                this.state.dragging &&
                                this.state.dragOverIndex === index &&
                                this.state.draggedIndex !== index

                            let fieldFull = DragDropFunctions.customFields[field.value] || {}
                            let fieldLabel = fieldFull.description || field.value
                            return (
                                <div key={field.id || index} className='mar-b12' style={{ position: 'relative' }}>
                                    {showDropLine && this.state.insertPosition === 'top' && (
                                        <div style={{ ...dropLineStyle, top: -7 }} />
                                    )}
                                    {showDropLine && this.state.insertPosition === 'bottom' && (
                                        <div style={{ ...dropLineStyle, bottom: -7 }} />
                                    )}
                                    <div
                                        draggable={true}
                                        onDragStart={(e) => {
                                            e.dataTransfer.effectAllowed = 'move'
                                            e.dataTransfer.setData('text/html', index.toString())
                                            e.stopPropagation()
                                            this.handleDragStart(index)
                                        }}
                                        onDragEnter={(e) => this.handleDragEnter(index, e)}
                                        onDragLeave={(e) => this.handleDragLeave(e)}
                                        onDragOver={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            e.dataTransfer.dropEffect = 'move'
                                            this.handleDragEnter(index, e)
                                        }}
                                        onDrop={(e) => {
                                            e.stopPropagation()
                                            this.handleDrop(e, index)
                                        }}
                                        onDragEnd={this.handleDragEnd}
                                        style={cardStyle}
                                        onClick={() => {
                                            if (!this.state.dragging) {
                                                if (this.state.selectedField !== index) {
                                                    this.setState({ selectedField: index })
                                                }
                                            }
                                        }}
                                    >
                                        <Icons
                                            icon='drag'
                                            color='#0A0A0A'
                                            style={{ marginRight: '8px', cursor: 'move', marginBottom: '-3px' }}
                                        />
                                        <div
                                            className='form-group mar-b0'
                                            style={{ flex: '1', fontWeight: '600', fontSize: '13px' }}
                                        >
                                            {fieldLabel}
                                        </div>
                                        <div style={{ flex: '0 0', display: 'flex', alignItems: 'center' }}>
                                            <Icons
                                                icon='pencil'
                                                outerStyle={{
                                                    width: 24,
                                                    height: 24,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                                style={{ width: 15, height: 15 }}
                                                color='#0A0A0A'
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    this.setState({ editingField: index, addingField: true })
                                                }}
                                            />
                                            {!field.cantDelete && (
                                                <Icons
                                                    icon='bin'
                                                    outerStyle={{
                                                        width: 24,
                                                        height: 24,
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                    style={{ width: 15, height: 15 }}
                                                    color='#DD4340'
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        this.deleteField(index)
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <Button
                        className='button-primary'
                        onClick={() => this.setState({ addingField: true, editingField: null })}
                    >
                        Add Field
                    </Button>
                </div>
            </div>
        )
    }
}

function AddField({ existingFields = [], done = () => {}, selectedField = null, onFieldsChanged = () => {} }) {
    const [allFields, setAllFields] = useState()
    const [errors, setErrors] = useState({})
    const [field, setField] = useState({})
    const [fieldTypes, setFieldTypes] = useState([])

    const dispatch = useDispatch()

    useEffect(() => {
        if (selectedField !== null) {
            setField(existingFields[selectedField])
        }
        setAllFields(
            Object.keys(DragDropFunctions.customFields).map((field) => {
                let isDisabled = existingFields.some((existingField) => existingField.value === field)
                return {
                    value: field,
                    label: DragDropFunctions.customFields[field].description,
                    disabled: isDisabled,
                    fieldType: DragDropFunctions.customFields[field].type || '',
                    options: DragDropFunctions.customFields[field].options || []
                }
            })
        )
        axios.get('/customfield/fieldtypes').then((response) => {
            setFieldTypes(
                response.data.map((field) => {
                    return {
                        label: fieldTypeLabel(field.type),
                        value: field.type
                    }
                })
            )
        })
    }, [])

    const createdField = (newField) => {
        dispatch(alterSiteDrawer(false, false, 'right', undefined, false, '500px', undefined))
        allFields.push({
            value: newField.fieldName,
            label: newField.fieldDesc,
            disabled: false,
            fieldType: newField.type
        })
        setField({
            value: newField.fieldName,
            label: newField.fieldDesc,
            disabled: false,
            fieldType: newField.type
        })
    }

    const goAddField = () => {
        const selectedType =
            field?.fieldType || (selectedField !== null ? existingFields[selectedField]?.fieldType : undefined)
        var drawerContent = (
            <IncAddCustomField
                getCustomFields={createdField}
                excludeFieldsTypes={[]}
                forceType={forcedNewFieldType({ selectedType })}
                standalone={true}
            />
        )
        dispatch(alterSiteDrawer(true, true, 'right', drawerContent, true, '500px', undefined))
    }

    const submitForm = async () => {
        if (!field) {
            setErrors({ field: 'Field is required' })
            return
        }
        const fieldEntry = {
            value: field.value,
            label: field.label,
            required: field.required,
            fieldType: field.fieldType,
            options: field.options
        }
        const existingEntry = selectedField !== null ? existingFields[selectedField] : null
        if (existingEntry && existingEntry.value === field.value && existingEntry.cantDelete) {
            fieldEntry.cantDelete = true
        }
        const newFields =
            selectedField !== null
                ? existingFields.map((f, i) => (i === selectedField ? fieldEntry : f))
                : [...existingFields, fieldEntry]
        await onFieldsChanged(newFields)
        setField({})
        done()
    }

    return (
        <div className='dndEditorv2-dd_toolHolder'>
            <div className='dd_inputTool mar-b15'>
                <Select
                    label='Field'
                    name='field'
                    data={allFields}
                    className='dd_dragDrop'
                    onChange={(event) => {
                        const ourField = allFields.find((field) => field.value === event.target.value)
                        setField({
                            value: event.target.value,
                            label: ourField.label,
                            required: false,
                            fieldType: ourField.fieldType.toUpperCase(),
                            options: ourField.options || []
                        })
                    }}
                    value={field.value}
                    labelOptions={<a onClick={() => goAddField()}>Create new Field</a>}
                    error={errors.field}
                />
            </div>

            {field && field.value && (
                <>
                    <div className='dd_inputTool mar-b15'>
                        <Select
                            label='Type'
                            name='fieldType'
                            data={fieldTypes}
                            value={field.fieldType}
                            onChange={(event) => setField({ ...field, fieldType: event.target.value })}
                        />
                    </div>

                    <div className='dd_inputTool mar-b15'>
                        <TextInput
                            label='Label'
                            name='label'
                            value={field.label}
                            onChange={(event) => setField({ ...field, label: event.target.value })}
                            error={errors.label}
                        />
                    </div>

                    <div className='dd_inputTool mar-b15'>
                        <Toggle
                            after='Required Field'
                            name='required'
                            checked={field.required}
                            onChange={(event) => {
                                setField({ ...field, required: event.currentTarget.checked ? true : false })
                            }}
                        />
                    </div>

                    {(field?.fieldType?.toLowerCase() === 'select' ||
                        field?.fieldType?.toLowerCase() === 'multiselect') && (
                        <ArraySelectComponent
                            className='mar-b15'
                            value={field.options || []}
                            updateVal={(path, options) => {
                                setField({ ...field, options: options })
                            }}
                            path={''}
                            elementData={{}}
                            title='Options'
                        />
                    )}

                    <Button onClick={submitForm} className='button-primary'>
                        {selectedField !== null ? 'Update Field' : 'Add Field'}
                    </Button>
                </>
            )}
        </div>
    )
}
